import {
    DataRecordValue,
    DataRecord,
    getColumnLabel,
    CategoricalColorNamespace,
    getMetricLabel,
    getNumberFormatter,
} from '@superset-ui/core';
import { EChartsCoreOption, LineSeriesOption } from 'echarts';
import { defaultTooltip } from '../../../defaults';
import {
    DEFAULT_FORM_DATA as DEFAULT_CHART_FORM_DATA,
    EchartsLineChartProps,
    EchartsLineFormData,
    LineChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series'; 
import { sortKeys } from '../../utils';
  
export default function transformProps(
    chartProps: EchartsLineChartProps,
): LineChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metrics,
      smooth,
      colorScheme,
      sliceId,
      showLegend,
      sortLabels,
      numberFormat
    }: EchartsLineFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_CHART_FORM_DATA,
      ...formData,
    };

    const colorFn = CategoricalColorNamespace.getScale(colorScheme as string);

    const metricLabels = metrics ? metrics.map(getMetricLabel) : [];
    const categoryLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel) : [getColumnLabel(groupby)];

    const keys = data.map(datum =>
      extractGroupbyLabel({ datum, groupby: categoryLabels, coltypeMapping: {} }),
    );  
    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: categoryLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: categoryLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;

    sortKeys(keys, sortLabels);

    const numberFormatter = getNumberFormatter(numberFormat);
      
    const series: LineSeriesOption[] = metricLabels.map(metric => {
      return {
        name: metric,
        type: 'line',
        smooth,
        stack: 'Total',
        color: colorFn(metric, sliceId),
        areaStyle: {},
        emphasis: {
          focus: 'series'
        },
        // @ts-ignore
        data: data.map(datum => datum[metric] as LineDataValue)
      }
    });

    const echartOptions: EChartsCoreOption = {
      tooltip: {
        ...defaultTooltip,
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
        }
      },
      legend: {
        show: showLegend,
        data: metricLabels
      },
      series,
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: keys,
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: numberFormatter
          }
        }
      ]
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby
    };
}
  